import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { holdItemShape } from '@bibliocommons/bc-prop-types';

import * as HoldActions from 'app/actions/HoldActions';
import { selectCurrentAccount } from 'app/selectors/AuthSelector';
import { selectHoldsWithBibsById } from 'app/selectors/HoldsSelector';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import { BatchCancelHoldWorkflowView } from './BatchCancelHoldWorkflowView';

export function BatchCancelHoldWorkflowContainer(props) {
  return (
    <BatchCancelHoldWorkflowView
      handleClose={props.closeWorkflow}
      cancelHold={props.holdActions.cancelHold}
      accountId={props.accountId}
      holdIds={props.holdIds}
      messagingId={props.messagingId}
      workflowId={props.workflowId}
      isLoading={props.isLoading}
      shelves={props.shelves}
      done={props.done}
      bibs={props.items.map(item => item && item.getIn(['bib', 'briefInfo']))}
    />
  );
}

const mapStateToProps = (state, ownProps) => {
  const items = ownProps.holdIds.reduce(
    (holdsForIds, holdId) => holdsForIds.push(selectHoldsWithBibsById(state).get(holdId)),
    Immutable.List()
  );

  const isLoading = state.getIn(['ui', 'itemTransactions', ownProps.workflowId, 'isLoading']);
  const done = !items.some(item => item !== undefined);

  return {
    items,
    isLoading,
    done,
    accountId: selectCurrentAccount(state).get('id'),
    shelves: selectShelvesForCurrentUser(state)
  };
};

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch)
});

BatchCancelHoldWorkflowContainer.propTypes = {
  holdIds: ImmutablePropTypes.listOf(PropTypes.string),
  items: ImmutablePropTypes.listOf(holdItemShape),
  workflowId: PropTypes.string,
  closeWorkflow: PropTypes.func,
  accountId: PropTypes.number,
  holdActions: PropTypes.objectOf(PropTypes.func),
  messagingId: PropTypes.string,
  isLoading: PropTypes.bool,
  done: PropTypes.bool,
  shelves: ImmutablePropTypes.map
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchCancelHoldWorkflowContainer);
